import { render, staticRenderFns } from "./SaldoEntrada.vue?vue&type=template&id=5667e432"
import script from "./SaldoEntrada.vue?vue&type=script&lang=js"
export * from "./SaldoEntrada.vue?vue&type=script&lang=js"
import style0 from "./SaldoEntrada.vue?vue&type=style&index=0&id=5667e432&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports